import React, { Fragment } from 'react';
import { Button, Divider, Form, Input, Modal, notification, Select, Spin, Typography } from "antd";
import ApiService from "../../../services/ApiService";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddTag extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialstate = {
        visible: false,
        loading: true,
        contacts: [],
        initialTags: [],
        categories: [],
        selectedCategories: [],
    };

    state = this.initialstate

    async show(contacts, initialTags = []) {
        await this.init();
        this.setState({ visible: true, contacts: contacts, initialTags: initialTags });
    }

    close() {
        this.setState(this.initialstate);
    }

    componentDidMount() {
        this.init();
    }

    async init() {
        var res = await ApiService.get("/contact/categories");
        if (res.success) {
            this.setState({ categories: res.items, loading: false });
        }
    }

    async onSelect() {
        var res = await ApiService.post("/contact/multi/addtag/", {
            tags: this.state.selectedCategories,
            contacts: this.state.contacts
        });

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            });

            this.close();
            if (this.props.onFinish) {
                this.props.onFinish();
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            });
        }
    }

    render() {
        return (
            <Modal
                width="90%"
                title={t`Ajouter des catégories`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Spin spinning={this.state.loading}>
                    {!this.state.loading && (
                        <Fragment>
                            <Form.Item
                                label={<Trans>Catégories</Trans>}
                                rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                            >
                                <Select
                                    mode="tags"
                                    placeholder={t`Catégories`}
                                    value={this.state.selectedCategories}
                                    onSelect={(value) => {
                                        const newArray = [...this.state.selectedCategories, value];
                                        this.setState({ selectedCategories: newArray });
                                    }}
                                    onDeselect={(value) => {
                                        const newArray = this.state.selectedCategories.filter(i => i !== value);
                                        this.setState({ selectedCategories: newArray });
                                    }}
                                >
                                    {this.state.categories
                                        .filter(i => !this.state.selectedCategories.includes(i) && !this.state.initialTags.includes(i))
                                        .map((item, index) => (
                                            <Option key={index} value={item}>{item}</Option>
                                        ))}
                                </Select>
                            </Form.Item>

                            <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.state.loading}
                                    onClick={() => this.onSelect()}
                                >
                                    <Trans>Valider</Trans>
                                </Button>
                            </Form.Item>
                        </Fragment>
                    )}
                </Spin>
            </Modal>
        )
    }
}
